import React from "react";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Share2, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRIMARY_URL, BACKUP_URL } from "@/lib/backendUrl";

const copy = async (text, label) => {
  try { await navigator.clipboard.writeText(text); toast.success(`${label} copied`); }
  catch { toast.error("Couldn't copy — long-press the link instead"); }
};

export const ShareLinkCard = ({ title = "Share this page" }) => {
  const path = window.location.pathname;
  const main = `${PRIMARY_URL}${path}`;
  const backup = `${BACKUP_URL}${path}`;
  const shareText = `${title}\n${main}\n\nIf that link doesn't open on your network, use:\n${backup}`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "NeuralDeck", text: shareText }); } catch { /* cancelled */ }
    } else copy(shareText, "Both links");
  };

  return (
    <section className="p-5 rounded-2xl border border-[#1E2638] bg-[#121620] space-y-4" data-testid="share-link-card">
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00F0FF]">// {title}</div>
      <div className="flex gap-4 items-center">
        <div className="p-2 bg-white rounded-xl flex-shrink-0" data-testid="share-link-qr">
          <QRCodeSVG value={main} size={96} level="M" bgColor="#ffffff" fgColor="#0B0E14" />
        </div>
        <div className="space-y-2 min-w-0 flex-1">
          <div className="text-xs text-[#94A3B8] break-all" data-testid="share-link-main">{main}</div>
          <div className="flex flex-wrap gap-2">
            <Button size="sm" data-testid="share-link-copy" onClick={() => copy(main, "Link")} variant="outline" className="border-[#2A354B] bg-transparent text-white hover:bg-white/5">
              <Copy className="w-3.5 h-3.5 mr-1.5" /> Copy
            </Button>
            <Button size="sm" data-testid="share-link-share" onClick={share} className="bg-[#00F0FF] text-black hover:bg-[#33F3FF]">
              <Share2 className="w-3.5 h-3.5 mr-1.5" /> Share
            </Button>
          </div>
        </div>
      </div>
      <div className="text-[11px] text-[#64748B] font-mono leading-relaxed">
        Link not opening for someone? Send the backup:{" "}
        <button data-testid="share-link-backup-copy" onClick={() => copy(backup, "Backup link")} className="text-[#00F0FF] underline break-all text-left">{backup}</button>
        {" · "}
        <a href={`${BACKUP_URL}/help`} data-testid="share-link-help" className="inline-flex items-center gap-1 text-[#94A3B8] hover:text-[#00F0FF]"><LifeBuoy className="w-3 h-3" />Help</a>
      </div>
    </section>
  );
};
